import React from "react";
import Layout from "../../../layouts";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { GoalSettingTabMenu } from "../GoalSettingTabMenu";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useTranslation } from "react-i18next";
import { common } from "../../../i18n";
import { GoalDashboardProvider } from "../../../contexts/GoalSettingDashboardContext";
import { GoalSelectionBar } from "./GoalSelectionBar";
import { GoalSettingDashboardList } from "./goal-component/GoalSettingDashboardList";
import { GoalSettingProvider } from "../../../contexts/GoalSettingContext";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const DashboardGoalSetting = () => {
  const { t } = useTranslation([common], {
    nsMode: "fallback",
  });
  return (
    // <GoalSettingProvider>
        <Layout>
      <GoalDashboardProvider>
          <Box
            display={"flex"}
            flexDirection={"column"}
            flex={1}
            height={"100%"}
            color={"var(--dark)"}
          >
            
            <GoalSettingTabMenu />
            <Box
              p={"40px 40px"}
              display={"flex"}
              flexDirection="column"
              bgcolor={"var(--white)"}
              gap={"40px"}
              alignItems={"start"}
              flex={1}
            >
              <Grid2
                rowGap={"20px"}
                width={"100%"}
                justifyContent={"space-between"}
              >
                <GoalSelectionBar />
              </Grid2>
              <Box
                display="flex"
                alignItems="center"
                gap={1.5}
                bgcolor="var(--gray3)"
                p="12px 16px"
                borderRadius="8px"
                width="100%"
                boxSizing="border-box"
                alignSelf="stretch"
              >
                <InfoOutlinedIcon color="primary" />
                <Typography variant="h4" color={"primary"}>
                  {t("Note")}:
                </Typography>
                <Typography variant="body1" color={"primary"}>
                  {t("Display-a-maximum-of-5-goals")}
                </Typography>
              </Box>
              <Grid2 xs={12} width={"100%"}>
                <GoalSettingDashboardList />
              </Grid2>
            </Box>
          </Box>
            </GoalDashboardProvider>
        </Layout>
    // </GoalSettingProvider>
  );
};

export default DashboardGoalSetting;